export const WEBSITES_RESULTS_TABLE_KEY = "websites-results-table";

export const LEADS_EXPORT_SELECTION_TOP_N_VALUES: readonly number[] = [50, 100, 250, 500, 1_000, 5_000, 10_000, 50_000];

export const MAX_LEADS_EXPORT_SELECTION_TOP_N_VALUE = 1000;

export const LEADS_CRM_EXPORT_SELECTION_TOP_N_VALUES: readonly number[] = [50, 100, 250, 500, 1_000];

export const MAX_LEADS_CRM_EXPORT_SELECTION_TOP_N_VALUE = 1000;

export const LEADS_ASSIGN_SELECTION_TOP_N_VALUES: readonly number[] = [50, 100, 250, 500, 1_000];
